export default {
  settings: 'Account',
  header: 'Notification Preferences',
  columns: {
    description: 'Event',
    inAppMessage: 'In-app Message',
    email: 'Email',
    textMessage: 'Text Message'
  },
  errors: {
    invalidPhoneNumber: 'You do not have a verified phone number and cannot receive text messages from Wonolo.'
  },
  toasts: {
    updateSuccess: 'Preferences successfully updated.',
  }
};
